export default __webpack_public_path__ + "static/media/ltr_testimonials_background.cebc9081.png";